import { useImmer } from "use-immer";
import { useEffect } from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faPlus } from "@fortawesome/free-solid-svg-icons";
import { faTrashCan } from "@fortawesome/free-solid-svg-icons/faTrashCan";

const Component = ({ config, onChange }) => {
  const scoreConfigTemplate = {
    countryCode: "",
    litres: [0, 0],
  };
  const [data, updateData] = useImmer(config);
  const [visibleCount, setVisibleCount] = useImmer(5);

  useEffect(() => {
    updateData(config);
  }, [config]);

  useEffect(() => {
    onChange(data);
  }, [data]);

  const addScore = () => {
    updateData((d) => {
      d.countryLitres.push(structuredClone(scoreConfigTemplate));
    });
  };

  const removeScore = (index) => {
    updateData((d) => {
      d.countryLitres.splice(index, 1);
    });
  };

  const total = data.countryLitres?.length || 0;
  const rows = data.countryLitres.slice(0, visibleCount);

  return (
    <>
      <table className="config-table">
        <thead>
          <tr>
            <th>Attribute</th>
            <th>Value</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>
              History min <small>[minutes]</small>
            </td>
            <td>
              <input
                type="number"
                value={data.minimalMinutes}
                max={-1}
                onChange={(e) =>
                  updateData((d) => {
                    d.minimalMinutes = e.target.value;
                  })
                }
              />
            </td>
          </tr>
        </tbody>
      </table>

      <table className="config-table">
        <thead>
          <tr>
            <th>Score header</th>
            <th>Suspicious</th>
            <th>Very suspicious</th>
          </tr>
        </thead>
        <tbody>
          <tr>
            <td>&nbsp;</td>
            {data.scores.map((score, index) => (
              <td key={index}>
                <input
                  type="number"
                  value={score}
                  step="0.1"
                  min={0}
                  onChange={(e) =>
                    updateData((d) => {
                      d.scores[index] = e.target.value;
                    })
                  }
                />
              </td>
            ))}
          </tr>
        </tbody>
      </table>

      <table className="config-table table-with-button">
        <thead>
          <tr>
            <th>Country code</th>
            <th>
              Volume <small>[litres]</small>
            </th>
            <th></th>
            <th>
              <FontAwesomeIcon
                icon={faPlus}
                className="icon-clickable"
                onClick={() => addScore()}
              />
            </th>
          </tr>
        </thead>
        <tbody>
          {rows.map((countryLitre, index) => (
            <tr key={index}>
              <td>
                <input
                  type="text"
                  value={countryLitre.countryCode}
                  onChange={(e) =>
                    updateData((d) => {
                      d.countryLitres[index].countryCode = e.target.value;
                    })
                  }
                />
              </td>
              <td>
                <input
                  type="number"
                  value={countryLitre.litres[0]}
                  min={0}
                  max={countryLitre.litres[1]}
                  onChange={(e) =>
                    updateData((d) => {
                      d.countryLitres[index].litres[0] = e.target.value;
                    })
                  }
                />
              </td>
              <td>
                <input
                  type="number"
                  value={countryLitre.litres[1]}
                  min={countryLitre.litres[0]}
                  onChange={(e) =>
                    updateData((d) => {
                      d.countryLitres[index].litres[1] = e.target.value;
                    })
                  }
                />
              </td>
              <td>
                <FontAwesomeIcon
                  icon={faTrashCan}
                  className="icon-clickable"
                  onClick={() => removeScore(index)}
                />
              </td>
            </tr>
          ))}
          {total > visibleCount && (
            <tr>
              <td colSpan={4} style={{ textAlign: "center" }}>
                <span
                  onClick={() => setVisibleCount(total)}
                  style={{ cursor: "pointer", textDecoration: "underline" }}
                >
                  Show more
                </span>
              </td>
            </tr>
          )}
          {total > 5 && visibleCount === total && (
            <tr>
              <td colSpan={4} style={{ textAlign: "center" }}>
                <span
                  onClick={() => setVisibleCount(5)}
                  style={{ cursor: "pointer", textDecoration: "underline" }}
                >
                  Show less
                </span>
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </>
  );
};

export default Component;
